import React from 'react';
import EstimationBlock from '../templates/common/estimationBlock';
import SliderControllerBlock from '../templates/common/sliderControllerBlock';
import formatCurrencyToLocal from '../../../helpers/utils/formatCurrencyToLocal';
import { plural } from 'utils/plural';

export default function template(context) {
    const calc = context.calc,
      phraseArray = ['CALCULATOR_FULL_MONTHS_02', 'CALCULATOR_FULL_MONTHS_01','CALCULATOR_FULL_MONTHS'],
      model = calc.state.model,
      selectOptions = (
        <>
          {model.getListOfCredits().map((item, index) => {
            return (
              <button
                key={item}
                name={item}
                className={`controllers-calculator-new__btn controllers-calculator-new__btn_${index + 1} ${model.currentName === item ? 'active' : ''}`}
                onClick={calc.toggleMode}
              >
                {calc.l10n(item.toUpperCase())}
              </button>
            );
          })}
        </>
      );

  const estimationData = [
    {
      label: calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW'),
      value: `${formatCurrencyToLocal(model.getRequiredPayment())} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN'),
      value: `${model.getCreditSum().toLocaleString()} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_BID'),
      value: `${formatCurrencyToLocal(model.getCreditRate(), {minimumFractionDigits: 1, maximumFractionDigits: 1})} ${calc.l10n('PERCENT')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_COMMISSION'),
      value: `${formatCurrencyToLocal(model.getMonthCommission(), {minimumFractionDigits: 1, maximumFractionDigits: 1})}${calc.l10n('PERCENT')}`,
    },
    {
      label: calc.l10n('CALCULATOR_OVERPAYMENT'),
      value: `${formatCurrencyToLocal(model.getOverpayment())} ${calc.l10n('UAH_ICON')}`,
    },
  ];
  
  return (
    <>
      <div className="calculator-new__top top-calculator-new">
        <div className="top-calculator-new__body">
          <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_TITLE')}</h2>
          <div className="top-calculator-new__base-rate">
            {calc.l10n("CALCULATOR_NEW_AEXPRESS_BASE_RATE")}
          </div>
        </div>
      </div>
      <div className="calculator-new__bottom">
        <div className="calculator-new__controllers controllers-calculator-new">
          <div className="controllers-calculator-new__title">
            {calc.l10n('CALCULATOR_NEW_AEXPRESS_CONTROLLER_FORMAT_TITLE')}
          </div>
          <div className={`controllers-calculator-new__row controllers-calculator-new__row_${model.getListOfCredits().length}`}>
            {selectOptions}
          </div>
        </div>
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_AEXPRESS_CONTROLLER_SUM_TITLE')}
          titleNote={`${calc.l10n('CALCULATOR_NEW_AEXPRESS_CONTROLLER_SUM_TITLE_NOTE_01')} ${model.getMaxSumEdge().toLocaleString('uk-UA')} ${calc.l10n('CALCULATOR_NEW_AEXPRESS_CONTROLLER_SUM_TITLE_NOTE_02')}`}
          inputName="creditSum"
          value={model.getCreditSum()}
          currency={calc.l10n('UAH_ICON')}
          min={model.getMinSumEdge()}
          max={model.getMaxSumEdge()}
          step={model.getSumStep()}
          currencyOffset={calc.state.valueWith}
          hiddenValueRef={calc.hiddenValue}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange}
          showError={false}
        />
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_AEXPRESS_DESIRED_CREDIT_TERM')}
          inputName="loanTerm"
          value={model.getCurrentTerm()}
          currency={calc.l10n(`${plural(model.getCurrentTerm(), phraseArray )}`)}
          min={model.getMinTermEdge()}
          max={model.getMaxTermEdge()}
          step={1}
          currencyOffset={calc.state.valueWidth2}
          hiddenValueRef={calc.hiddenValue2}
          onRangeChange={calc.handleChange1}
          showError={false}
          readOnly={true}
        />
        <EstimationBlock
          title={calc.l10n('CALCULATOR_NEW_ESTIMATION_TITLE')}
          items={estimationData}
        />
        <button className="calculator-new__order-btn" onClick={calc.props.onBtnClick} id={`${calc.props.page ? calc.props.page : ''} calculator-new-button`}>
          {calc.l10n('EXPRESS_APPLICATION_APPLY_BTN')}
        </button>
        <div className='calculator-new__hint-info' dangerouslySetInnerHTML={{__html: calc.l10n("CALCULATOR_NEW_AEXPRESS_HINT_INFO")}}></div>
      </div>
    </>
  );
}
